import React from "react";

export default function BudgetProgress({ value, max, testId, showText = true }) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const over = value > max && max > 0;
  let fill = "hsl(225 45% 20%)";
  if (pct >= 80 && pct <= 100) fill = "hsl(45 85% 50%)";
  if (over) fill = "hsl(0 70% 45%)";

  return (
    <div data-testid={testId} className="w-full">
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className="h-full transition-all duration-700 ease-out"
          style={{ width: `${Math.min(100, pct)}%`, backgroundColor: fill }}
        />
      </div>
      {showText && (
        <div className="mt-1.5 flex items-center justify-between text-xs">
          <span className="mono tabular text-muted-foreground">
            ${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            <span className="opacity-50"> / </span>
            ${max.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
          <span
            className="mono text-[11px] font-medium"
            style={{ color: over ? "hsl(0 70% 45%)" : pct >= 80 ? "hsl(40 95% 30%)" : "hsl(220 30% 35%)" }}
          >
            {pct.toFixed(0)}%{over ? " · OVER" : ""}
          </span>
        </div>
      )}
    </div>
  );
}
